import Cookies from "universal-cookie";

const gtmCookieName = "cookie-consent";

const cookies = new Cookies();
const getGtmConsent = () => cookies.get(gtmCookieName);
const setGtmConsent = (value) => cookies.set(gtmCookieName, value);

export default { getGtmConsent, setGtmConsent };
